/**
 * search focus on open
 */
export function searchBoxFocusInit() {
    const backdrop = document.querySelector('.site__backdrop');
    const backdropActiveClass = 'site__backdrop--show';
    let searchFormDropdown = document.querySelector('#searchForm');

    searchFormDropdown?.addEventListener('show.bs.collapse', () => {
        backdrop?.classList.add(backdropActiveClass);
    });

    searchFormDropdown?.addEventListener('shown.bs.collapse', () => {
        let searchFormInput = searchFormDropdown.querySelector('.form-control');
        searchFormInput?.focus();
    });

    searchFormDropdown?.addEventListener('hide.bs.collapse', () => {
        backdrop?.classList.remove(backdropActiveClass);
    });
}